// extracted by mini-css-extract-plugin
export default {"outer":"NotFound_outer__1imPn"};